import script from "./Interim2.vue?vue&type=script&lang=ts&setup=true"
export * from "./Interim2.vue?vue&type=script&lang=ts&setup=true"

import "./Interim2.vue?vue&type=style&index=0&id=88baed54&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88baed54"]])

export default __exports__